webpackJsonp([9883378295937],{

/***/ 729:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(3);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Quickstart = __webpack_require__(9);
	
	var _Quickstart2 = _interopRequireDefault(_Quickstart);
	
	var _Markdown = __webpack_require__(5);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	var _CodeTabs = __webpack_require__(7);
	
	var _CodeTabs2 = _interopRequireDefault(_CodeTabs);
	
	var _CodeTab = __webpack_require__(6);
	
	var _CodeTab2 = _interopRequireDefault(_CodeTab);
	
	var _QuickstartBranch = __webpack_require__(8);
	
	var _QuickstartBranch2 = _interopRequireDefault(_QuickstartBranch);
	
	var _final = __webpack_require__(133);
	
	var _final2 = _interopRequireDefault(_final);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    _Quickstart2.default,
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      'Infinite Scrolling: Overview'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'In this section we\'ll replace the pagination links with an infinite scrolling approach.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'At the end of this section your application will look like this:'
	    ),
	    _react2.default.createElement('img', { className: 'drop-shadow', src: _final2.default }),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Infinite Scrolling vs Pagination'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Infinite Scrolling differs from pagination in the following ways:'
	    ),
	    _react2.default.createElement(
	      'ol',
	      null,
	      _react2.default.createElement(
	        'li',
	        null,
	        'Instead of letting the user select a page, they can only load the next page'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'Instead of displaying one page at a time, the results are all combined into a single list'
	      )
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'It\'s important to point out that these are ',
	      _react2.default.createElement(
	        'strong',
	        null,
	        'view specific concerns'
	      ),
	      ', meaning nothing about creating the experience requires changes to infrastructure or to the API. These needs are all related to how a user ',
	      _react2.default.createElement(
	        'em',
	        null,
	        'interacts'
	      ),
	      ' with data, and have nothing to do with ',
	      _react2.default.createElement(
	        'em',
	        null,
	        'how data is fetched or stored'
	      ),
	      '.'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Our Strategy'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'There\'s a lot of boilerplate associated with Infinite Scrolling, but it breaks down into two main components:'
	    ),
	    _react2.default.createElement(
	      'ul',
	      null,
	      _react2.default.createElement(
	        'li',
	        null,
	        'The first is a ',
	        _react2.default.createElement(
	          'code',
	          null,
	          'List'
	        ),
	        ' that can keep track of all the pages of data, and merges them into a single array. This component also needs to know how to render each item in the array.'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'The second is a ',
	        _react2.default.createElement(
	          'code',
	          null,
	          'Button'
	        ),
	        ' that the user can press to load the next page of data, which means it also needs to know when there ',
	        _react2.default.createElement(
	          'em',
	          null,
	          'is'
	        ),
	        ' a next page.'
	      )
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Our strategy will be to create those two components first, and then use them to convert our Feed into an Infinite Scrolling experience.'
	    ),
	    _react2.default.createElement(
	      'h2',
	      null,
	      'Next Steps'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Ready? Let\'s ',
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: '../step-1/' },
	        'get started'
	      ),
	      '!'
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-quickstart-infinite-scrolling-overview-js-5b171bea9400133eae60.js